
import "./Hero.scss";
import { TagCloud } from 'react-tagcloud'
import AutoTyping from '../AutoTyping/AutoTyping';
import traducciones from '../../traducciones/traducciones'
const Hero = ({ lang }) => {
  const isMobile = () => window.outerWidth < 1024
  const contenido2 = "Full Stack Developer."
  const contenido1 = "Martin Barreiro"


  const data = [
    // { value: 'MongoDb', count: 10 },
    { value: 'Architecture', count: 22 },
    { value: 'Scalability', count: 22 },
    { value: 'AI', count: 22 },
    { value: 'Realtime', count: 22 },
    { value: 'UX', count: 22 },
    { value: 'Performance', count: 22 },
    { value: 'Design Systems', count: 22 },
    { value: 'APIs', count: 22 },
  ]
  const customRenderer = (tag, size, color) => (
    <span className="cmp-hero__custom-tag"
      key={tag.value}
      style={{
        animation: 'float 4s linear infinite',
        animationDelay: `${Math.random() * 2}s`,
        fontSize: `${size / 1.3}em`,
        // boxShadow: `-5px 0px 20px ${color}`,
      }}
    >
      {tag.value}
    </span>
  )
  return (
    <div className="cmp-hero">
      <div className="cmp-hero-content">
        <div className="cmp-hero-content__wrapper">
          <h1>
            <span className="cmp-hero-content__line-1">{traducciones[lang].hero}</span>
            <AutoTyping contenido={contenido1} />
            {/* <span className="cmp-hero-content__line-2">Martin Barreiro</span> */}
          </h1>
          <AutoTyping contenido={contenido2} />
        </div>
      </div>
      <div className="cmp-hero-media">
        <div className="cmp-hero-media__wrapper">
          <TagCloud
            minSize={1}
            maxSize={isMobile() ? 4 : 7}
            tags={data}
            renderer={customRenderer}
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
